import { render } from "./Actualites.vue?vue&type=template&id=0c9b04ad"
import script from "./Actualites.vue?vue&type=script&lang=js"
export * from "./Actualites.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__